import React from "react";
import { getIsDocumentHidden, getBrowserVisibilityProp } from "../../utils/visibility.jsx";

export function usePageVisibility() {
  const [isVisible, setIsVisible] = React.useState(getIsDocumentHidden());

  React.useEffect(() => {
    const visibilityChange = getBrowserVisibilityProp();
    const onVisibilityChange = () => setIsVisible(getIsDocumentHidden());

    window.addEventListener(visibilityChange, onVisibilityChange, false);

    return () => {
      window.removeEventListener(visibilityChange, onVisibilityChange);
    };
  }, []);

  return isVisible;
}
